<template>
  <NewsletterSubscriptionForm
    class="magazine-newsletter-form"
    :title="title"
    :subtitle="subtitle"
    :images="images"
    title-class="text-h5"
    text-class="text-base"
    wrapper-class="my-8"
    container-class="p-6"
    form-class="md:mt-auto"
  />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    image1?: string
    image2?: string
  }>(),
  {
    title: '',
    subtitle: '',
    image1:
      'https://d1sos1r10s6do5.cloudfront.net/cms-media/tufting_f2fe8ea286.jpg',
    image2:
      'https://d1sos1r10s6do5.cloudfront.net/cms-media/malkurs_6d9232748c.jpg',
  }
)

const images = computed(() => {
  return [props.image1, props.image2].map((item) => {
    return {
      image: {
        url: item,
      },
    }
  })
})
</script>

<style lang="postcss">
.magazine-newsletter-form .image-container img {
  margin: 0;
  width: 100%;
}
</style>
